import { WarningCircleIcon, BrainIcon } from '@phosphor-icons/react'
import { ScoopCenter, ScoopColumn, ScoopText } from '../../../../ui'
import styles from './ReportState.module.scss'

/**
 * ReportState — the ONE empty/error presentation for the DI tab
 * (target-state design §4, review D13/D14). Before this, errors wore four
 * different costumes and empty states were dead ends.
 *
 * - variant="error": red icon, title, message, and the resolving action
 *   (usually a Retry button supplied by the caller).
 * - variant="empty": tertiary icon, title, one-line why, and the action that
 *   resolves the empty state (never a dead end).
 */
export const ReportState = ({
    variant = 'empty',
    icon,
    title,
    message,
    action,
    className,
}) => {
    const isError = variant === 'error'
    const IconComponent = isError ? WarningCircleIcon : icon || BrainIcon
    return (
        <ScoopCenter className={`${styles.state} ${className || ''}`}>
            <ScoopColumn className={styles.content}>
                <IconComponent
                    size={isError ? 32 : 48}
                    weight={isError ? 'fill' : 'regular'}
                    className={isError ? styles.errorIcon : styles.emptyIcon}
                />
                <ScoopText className={styles.title}>{title}</ScoopText>
                {message && <ScoopText className={styles.message}>{message}</ScoopText>}
                {action}
            </ScoopColumn>
        </ScoopCenter>
    )
}
